import { Module } from "wrapper6";
import Glide from '@glidejs/glide';
import { ArrowControls } from '../utils/_glide-plugins';

export default class DepartmentSlider extends Module {

    ready(app) {
        const SLIDER = document.querySelector('.mtt-department-gallery__thumbs');
        const ARROW = document.querySelector('.mtt-department-gallery__arrow');
        const MAIN_IMAGE = document.querySelector('.mtt-department-gallery__main img');
        let hasRun = false;

        if (SLIDER) {
            MAIN_IMAGE.setAttribute('srcset', '');
            MAIN_IMAGE.setAttribute('sizes', '');
            MAIN_IMAGE.setAttribute('height', '');
            MAIN_IMAGE.setAttribute('width', '');

            const GLIDER = new Glide(SLIDER, {
                type: 'carousel',
                perView: 2,
                gap: 16,
                peek: getPeekValue(),
                arrowClasses: {
                    back: 'mtt-department-gallery__arrow--left',
                    next: 'mtt-department-gallery__arrow--right'
                }
            });

            function getPeekValue() {
                const ARROW_WIDTH = ARROW.offsetWidth;

                return ARROW_WIDTH + 15;
            }

            function updatePeek() {
                GLIDER.update({
                    peek: getPeekValue()
                });
            }

            GLIDER.on(['mount.after'], function() {
                const SLIDE_IMGS = SLIDER.querySelectorAll('.object-fit img');

                if (SLIDE_IMGS.length > 0) {
                    for (let i = 0; i < SLIDE_IMGS.length; i++) {
                        const SLIDE_IMG = SLIDE_IMGS[i];

                        SLIDE_IMG.addEventListener('click', function() {
                            const IMG_SRC = this.getAttribute('src');
                            MAIN_IMAGE.setAttribute('src', IMG_SRC);
                        });
                    }
                }
                
            });

            GLIDER.on(['run.after'], function() {

                const ACTIVE_SLIDE = SLIDER.querySelector('.glide__slide--active img')

                const IMG_SRC = ACTIVE_SLIDE.getAttribute('src');
                MAIN_IMAGE.setAttribute('src', IMG_SRC);

            });

            GLIDER.mount({ ArrowControls });

            window.addEventListener('resize', updatePeek);
        }

    }
}